import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  private urlBase = environment.urlBase;

  private headers!: HttpHeaders;

  private token: string | null = '';

  constructor(

    private http: HttpClient,

  ) {
    //Declaramos el token para añadirlo a los headers
    this.token = localStorage.getItem('token');
    //Declaramos los headers que se enviaran en la petición
    this.headers = new HttpHeaders().set('Content-Type', 'application/json').set('X-Requested-With', 'XMLHttpRequest').set('Authorization', `Bearer ${this.token}`).set('api_key', 'metrica');
  }

  //Obtener el menu una vez hecho login
  getMenu(): Observable<any> {
    return this.http.post(`${this.urlBase}modules/getModules`, null, { headers: this.headers })
  }
}
